import React from "react";
import { Box } from "@mui/material";

export default function StatBox({ children, theme, sx, ...props }) {
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.mode === "dark" 
          ? "rgba(255, 255, 255, 0.05)" 
          : "rgba(0, 0, 0, 0.08)",
        borderRadius: 1,
        px: 1.5,
        py: 0.5,
        display: "inline-block",
        minWidth: 60,
        textAlign: "center",
        ...sx
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
